import React from 'react';
import { SCard } from '@chargebee/sting-react';
import { CBRetentionLogo } from '@bbkAdminComponents/cbretention-logo';

export const AuthPanel: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="tw-mx-auto tw-mt-24 tw-w-full tw-max-w-[530px] tw-px-4">
      <SCard border="solid" rounded padding="large">
        <CBRetentionLogo className="tw-mb-6 tw-h-10" />
        {children}
      </SCard>
    </div>
  );
};
